<p-card>
    <div class="col-12 md:col-12">
        <div class="p-fluid">
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong>Visitor Pass No</strong> </label>

                    <p-dropdown [options]="getAllVisitorPassList" optionLabel="name" [filter]="true" filterBy="name"
                        (onChange)="onVisitorPassNoSelected($event.value)" [showClear]="true"
                        placeholder="Select Visitor Pass No">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div class="flex align-items-center gap-2">
                                {{ selectedOption?.name }}
                            </div>
                        </ng-template>
                        <ng-template let-pass pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                {{ pass?.name }}
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <!-- <div class="field col">
                    <label><strong>Gate Out Date and Time</strong><span class="required-asterisk">*</span></label>
                    <p-calendar [showTime]="true" formControlName="date_and_time" icon="pi pi-calendar"
                        [showIcon]="true"></p-calendar>
                </div> -->
                <div class="field col">
                </div>
                <div class="field col">
                </div>
            </div>
        </div>
    </div>
</p-card> <br>
<p-card>
    <div header="Visitor Gate Pass">
        <form [formGroup]="visitorgatepass">
            <div class="p-fluid">
                <div class="flex-container">
                    <fieldset class="section gate-info">
                        <legend><strong> Gate Out Info</strong></legend>
                        <div style="margin-top: 20px;"></div>
                        <div class="grid-container" id="primary_address">
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Gate Pass No</strong></label>
                                <input pInputText formControlName="gate_pass_no" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Visitor Mobile No</strong></label>
                                <input pInputText formControlName="visitor_mobile_no" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Visitor Name</strong></label>
                                <input pInputText formControlName="visitor_name">
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong>Visitor Pass Date and Time</strong></label>
                                <p-calendar [showTime]="true" formControlName="date_and_time" dateFormat="dd/mm/yy"
                                    timeFormat="HH:mm:ss" icon="pi pi-calendar" [showIcon]="true"></p-calendar>
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Card No </strong></label>
                                <input pInputText formControlName="card_no" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> No of Persons</strong></label>
                                <input pInputText formControlName="no_of_persons" />
                            </div>
                            <!-- <div *ngIf="showFileUpload" class="grid-item"
                                style="display: flex; flex-direction: column; align-items: start;">
                                <p-fileUpload mode="basic" name="demo[]" accept="image/*,application/pdf"
                                    [maxFileSize]="1000000" (onSelect)="onVendorImageUpload($event)" chooseLabel="Photo"
                                    #fileInput></p-fileUpload>
                            </div> -->
                            <!-- <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong>Gate Out Date and Time</strong><span class="required-asterisk">*</span></label>
                                <p-calendar [showTime]="true" dateFormat="dd/mm/yy" timeFormat="HH:mm:ss" formControlName="gate_out_time" icon="pi pi-calendar"
                                    [showIcon]="true"></p-calendar>
                                </div>
                            </div> -->
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong>Gate Out Date and Time</strong><span
                                        class="required-asterisk">*</span></label>
                                <p-calendar inputId="calendar-24h" formControlName="gate_out_time" [showIcon]="true" [showTime]="true" />
                            </div>
                        </div>
                    </fieldset>
                    <div style="margin-top: 70px;"></div>
                    <fieldset class="section organisation-details">
                        <legend><strong> Organisation Details</strong></legend>
                        <div style="margin-top: 20px;"></div>
                        <div class="grid-container" id="primary_address">
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Organization Name</strong></label>
                                <input pInputText formControlName="organization_name" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Address1 </strong></label>
                                <input pInputText formControlName="address1" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Address2</strong></label>
                                <input pInputText formControlName="address2" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Pin Code</strong></label>
                                <input pInputText formControlName="pin_code" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> City</strong></label>
                                <input pInputText formControlName="city" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> State</strong> </label>
                                <input pInputText formControlName="state" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> District</strong></label>
                                <input pInputText formControlName="district" />
                            </div>
                            <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                                <label><strong> Country</strong> </label>
                                <input pInputText formControlName="country" />
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div style="margin-top: 30px;"></div>
                <fieldset class="section">
                    <legend><strong> Other Details</strong></legend>
                    <div style="margin-top: 20px;"></div>
                    <div class="grid-container" id="primary_address">
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Vehicle No</strong></label>
                            <input pInputText formControlName="vehicle_no" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Material </strong></label>
                            <input pInputText formControlName="material" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Description</strong></label>
                            <input pInputText formControlName="description" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Mobile No</strong></label>
                            <input pInputText formControlName="mobile_no" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Person To Meet</strong></label>
                            <input pInputText formControlName="person_to_meet" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong>Department</strong> </label>
                            <input pInputText formControlName="department" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Designation</strong></label>
                            <input pInputText formControlName="designation" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Purpose</strong></label>
                            <input pInputText formControlName="purpose" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Document Type</strong></label>
                            <input pInputText formControlName="document_type" />
                        </div>
                        <div class="grid-item" style="display: flex; flex-direction: column; align-items: start;">
                            <label><strong> Document No</strong></label>
                            <input pInputText formControlName="document_no" />
                        </div>
                    </div>
                </fieldset>
            </div>
            <div style="margin-top: 50px;"></div>
            <div style="text-align: center;">
                <p-button label="Submit" (click)="onSubmit()"></p-button>
            </div>
            <div class="field col">
                <p-button *ngIf="isDownload" label="Print" (click)="generatePdfWithQRCode()"></p-button>
            </div>
        </form>
    </div>
</p-card>
<p-toast></p-toast>